import type {CopilotChatThread} from '@github-ui/copilot-chat-types'

import type {CopilotChatState} from './copilot-chat-reducer'

export function getSelectedThread(
  state: Pick<CopilotChatState, 'selectedThreadID' | 'threads'>,
): CopilotChatThread | null {
  if (!state.selectedThreadID) return null
  return state.threads.get(state.selectedThreadID) || null
}
